angular.module('dpw.services')
    .factory('supportCaseService', [
        '$window', 'user', 'helpers', 'dpwStorage',
        function ($window, userService, helpers, dpwStorage) {
            return {
                isPartner: isPartner,
                check: function ($event) {
                    $event.preventDefault();

                    if (!RCDPW.isLogin) {
                        dpwStorage.setItem('previousUrl', RCDPW.entries.supportCheckCase.href, true);
                    }

                    window.open(RCDPW.entries.supportCheckCase.href, '_blank');
                }
            };

            function isPartner() {
                return userService.getUser().isPartner;
            }
        }
    ]);
